import React from "react";
import { SelectInput } from "react-admin";

const PROVINCES = ["BA", "BAT", "BR", "FG", "LE", "TA"].map((id) => ({
  id,
  name: id,
}));

const ProvinceInput = ({ ...props }) => (
  <SelectInput
    {...props}
    choices={PROVINCES}
    emptyText="ra.action.all.female"
  />
);
export default ProvinceInput;
